import React, { useState } from "react";
import { closeIcon, dropdown, menuIcon, newWosamLogo } from "../assets";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { navLinks } from "../constants";

const NewNavbar = () => {
  const [toggle, setToggle] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="fixed left-0 right-0 top-0 flex items-center justify-between text-black bg-[#FFFBF2] z-50 py-4 md:py-4 md:px-[100px] px-4 font-barlow font-semibold">
      <Link to="/" className="">
        <img src={newWosamLogo} alt="" className="md:h-[60px] h-10" />
      </Link>
      <div className="flex justify-center items-center gap-20">
        {/* {navLinks.map((item) => (
          <NavLink
            key={item.id}
            to={item.linkRoute}
            className="hover:text-black hidden md:block"
            style={({ isActive }) => {
              return {
                color: isActive ? "#FF9700" : "",
              };
            }}
          >
            {item.linkName}
          </NavLink>
        ))} */}

        <div className="md:flex items-center gap-16">
          {navLinks.map((item) => (
            <div className="relative group/item hidden md:block">
              <div className="text-center cursor-pointer">
                {item.linkRoute ? (
                  <NavLink
                    to={item.linkRoute}
                    className="hover:text-black hidden md:block"
                    style={({ isActive }) => {
                      return {
                        color: isActive ? "#FF9900" : "",
                      };
                    }}
                  >
                    {item.linkName}
                  </NavLink>
                ) : (
                  <div className="flex items-center gap-2 py-6">
                    <p className="group-hover/item:text-black">
                      {item.linkName}
                    </p>
                    <img
                      src={dropdown}
                      alt=""
                      className="block group-hover/item:hidden"
                    />
                    <img
                      src={dropdown}
                      alt=""
                      className="hidden group-hover/item:block"
                    />
                  </div>
                )}
              </div>
              {item.sublinks && (
                <div
                  className={`absolute top-16 left-0 bg-[#FFFBF2] grid p-2 gap-2 ${
                    item.sublinks?.length > 3
                      ? "min-w-[295px] grid-cols-2"
                      : "min-w-[200px] grid-cols-1"
                  } shadow-sm invisible group-hover/item:visible hover:visible border`}
                >
                  {item.sublinks?.map((item) => (
                    <Link
                      to={item.sublinkroute}
                      className="text-xs py-2 px-4 text-black cursor-pointer bg-[#FFF5DF] hover:bg-[#ffe9ba] flex items-center justify-between"
                    >
                      {item?.sublinkname}
                      {item?.cs && (
                        <span className="text-[8px] font-bold">
                          Coming Soon
                        </span>
                      )}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <a
        href='mailto:info@wosamapartments.com'
        className="md:py-3 py-2 px-6 text-white bg-[#00A859] font-bold md:block hidden"
        // onClick={() => navigate("/booking")}
      >
        Contact
      </a>

      <div className="block md:hidden">
        <img
          src={toggle ? closeIcon : menuIcon}
          className="md:hidden block h-6 w-6 cursor-pointer"
          alt=""
          onClick={() => setToggle(!toggle)}
        />
        <div
          className={`${
            toggle ? "flex" : "hidden"
          } h-[95vh] bg-black bg-opacity-90 text-white absolute top-20 right-0 -my-2 w-full pt-10 px-4`}
        >
          <ul className="list-none flex flex-col gap-10">
            {/* {navLinks.map((navLink) => (
              // <NavLink
              //   key={navLink.id}
              //   to={navLink.linkRoute}
              //   className="hover:text-primary font-medium"
              //   style={({ isActive }) => {
              //     return {
              //       color: isActive ? "#00A859" : "",
              //     };
              //   }}
              //   onClick={() => setToggle(false)}
              // >
              //   {navLink.linkName}
              // </NavLink>
            ))} */}
            {navLinks.map((item) => (
              <div className="relative group/item ">
                <div className="cursor-pointer">
                  {item.linkRoute ? (
                    <NavLink
                      to={item.linkRoute}
                      className="group-hover/item:text-primary"
                      style={({ isActive }) => {
                        return {
                          color: isActive ? "#FF9900" : "",
                        };
                      }}
                      onClick={() => {
                        setToggle(false);
                      }}
                    >
                      {item.linkName}
                    </NavLink>
                  ) : (
                    <div
                      className="relative flex items-center gap-4"
                      onClick={() => {
                        setToggleDropdown(!toggleDropdown);
                      }}
                    >
                      <p className=" group-hover/item:text-primary">
                        {item.linkName}
                      </p>
                      <img
                        src={toggleDropdown ? dropdown : dropdown}
                        alt=""
                        className="block"
                      />
                    </div>
                  )}
                </div>
                {toggleDropdown && item.sublinks && (
                  <div
                    className={`grid py-2 ${
                      item.sublinks?.length > 3
                        ? "min-w-[295px] grid-cols-2"
                        : "min-w-[150px] grid-cols-1"
                    } shadow-sm`}
                  >
                    {item.sublinks?.map((item) => (
                      <Link
                        to={item.sublinkroute}
                        className="text-sm py-2 px-4 hover:text-primary cursor-pointer flex items-center gap-2"
                        onClick={() => {
                          setToggle(false);
                        }}
                      >
                        {item?.sublinkname}
                        {item?.cs && (
                          <span className="text-[10px] font-bold">
                            (Coming Soon)
                          </span>
                        )}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div className="flex flex-col gap-6">
              <a
                href='mailto:info@wosamapartments.com'
                className="md:py-3 py-2 md:px-12 px-6 text-white bg-transparent hover:bg-[#e2e2e2] hover:outline-[#e2e2e2] font-semibold outline outline-1 outline-white hover:text-black"
                onClick={() => {
                  // navigate("/booking");
                  setToggle(false);
                }}
              >
                Contact
              </a>
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NewNavbar;
